/**
 * 华为域：策略执行记录 API 服务（CLAUDE.md §前端 API 服务层 — 按域分目录）。
 *
 * 与后端 Pydantic 模型 src.huawei.dtos.auto_ad_operate_result 对齐。
 *   - GET  /api/v1/huawei/auto-ad-operate-result         → 分页过滤查询（含媒体交互状态/响应报文）
 *   - GET  /api/v1/huawei/auto-ad-operate-result/enums   → 操作类型下拉枚举
 *
 * 数据源 t_huawei_auto_ad_operate_result（huawei_red_check 产出动作落库；
 * 华为 update_ad 尚未实现时 status / message 为空串）。
 */

import { request } from "../apiClient";

/** 策略执行记录单行（与后端 AutoAdOperateResultRecord 对齐，7 字段）。 */
export interface AutoAdOperateResultRecord {
  taskId: string;
  taskName: string;
  action_name: string;
  condition: string;
  status: string;
  message: string;
  created_time: string;
}

/**
 * 策略执行记录查询入参（与后端 AutoAdOperateResultQuery 对齐，字段均可选）。
 * 用 `type` 而非 `interface`：TS 中对象 type 别名可隐式满足 apiClient 的
 * `Record<string, ...>` 索引签名（interface 不行）。
 */
export type AutoAdOperateResultQuery = {
  ds_start?: string;
  ds_end?: string;
  taskId?: string;
  taskName?: string;
  action_name?: string;
  condition?: string;
  page?: number;
  page_size?: number;
};

/** 策略执行记录分页结果（与后端 AutoAdOperateResultPage 对齐）。 */
export interface AutoAdOperateResultPage {
  items: AutoAdOperateResultRecord[];
  total: number;
  page: number;
  page_size: number;
}

/** 策略执行记录下拉枚举（与后端 AutoAdOperateResultEnums 对齐）。 */
export interface AutoAdOperateResultEnums {
  action_name: string[];
}

/** 分页过滤查询策略执行记录。 */
export async function getAutoAdOperateResult(
  query: AutoAdOperateResultQuery,
): Promise<AutoAdOperateResultPage> {
  const data = await request<AutoAdOperateResultPage | null>(
    "/api/v1/huawei/auto-ad-operate-result",
    { query },
  );
  return (
    data ?? {
      items: [],
      total: 0,
      page: query.page ?? 1,
      page_size: query.page_size ?? 20,
    }
  );
}

/** 取操作类型下拉枚举（DISTINCT 自表）。 */
export async function getAutoAdOperateResultEnums(): Promise<AutoAdOperateResultEnums> {
  const data = await request<AutoAdOperateResultEnums | null>(
    "/api/v1/huawei/auto-ad-operate-result/enums",
  );
  return data ?? { action_name: [] };
}
